/**
 * Iter133 — Shareable Ops Plan viewpoint page.
 * Opens a single Ops Plan viewpoint for anyone with case access.
 */
import React from 'react';
import { useParams, Link } from 'react-router-dom';
import OpsPlanTab from '../components/case/OpsPlanTab';
import { Button } from '../components/ui/button';
import { ArrowLeft } from 'lucide-react';

export default function OpsPlanSharedPage() {
  const { caseId, planId } = useParams();
  return (
    <div className="p-4 space-y-3" data-testid="ops-plan-shared-page">
      <div className="flex items-center justify-between gap-3 flex-wrap">
        <div>
          <h1 className="text-xl font-bold text-white">Operation Viewpoint</h1>
          <p className="text-xs text-slate-400">Shared from case {caseId}</p>
        </div>
        <Link to={`/cases/${caseId}`}>
          <Button variant="outline" size="sm" className="border-slate-600 text-slate-200">
            <ArrowLeft className="w-4 h-4 mr-1" /> Open Case
          </Button>
        </Link>
      </div>
      <OpsPlanTab caseId={caseId} initialPlanId={planId} />
    </div>
  );
}
